import { z } from 'zod';

export const PlatformStatisticsSchema = z.object({
  activePredictors: z.number(),
  avgSuccessRate: z.number(),
  totalPredictions: z.number(),
  totalDuels: z.number(),
  totalManagers: z.number(),
  /** Present on current API; default keeps older responses/cache from failing parse. */
  aiModelsCount: z.number().min(0).default(0),
  totalGWPredictions: z.number(),
  totalGWDuels: z.number(),
});

export type PlatformStatistics = z.infer<typeof PlatformStatisticsSchema>;

